import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Schriften selbst gehostet — die App soll auch offline im Keller funktionieren.
// Nur die Gewichtsachse und nur Latein: die App spricht durchgehend Deutsch.
import '@fontsource-variable/bodoni-moda/wght.css'
import '@fontsource-variable/fraunces/wght.css'
import '@fontsource-variable/archivo/wght.css'
import '@fontsource/courier-prime/latin-400.css'
import '@fontsource/courier-prime/latin-700.css'

import './styles/theme.css'
import { halteAktuell } from './api/fassung.js'
import { wendeThemaAn } from './api/thema.js'
import { App } from './App'

// Das Gewand steht, bevor der erste Pixel faellt — sonst blitzt das andere auf.
wendeThemaAn()

// Und die App fragt von sich aus nach neuen Fassungen.
halteAktuell()

const wurzel = document.getElementById('wurzel')
if (!wurzel) throw new Error('Wurzelelement fehlt.')

createRoot(wurzel).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
